// @ vendors
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
// @ constants
const actionTypes = require('constants/actionTypes');
const gdprConsentsActions = require('actions/gdprConsents');

// @actions
const {
    hireContractFailure,
    hireContractSuccess,
} = require('actions/contracts');
const { setTermsAndCondsInfo } = require('actions/termsAndCondsInfo');
const signaturePatternActions = require('actions/signaturePattern');

const {
    //DEPOSIT_HIRE_CONFIRMATION_PRODUCT_SUBTYPE,//Should be using this one, but in PRE environment only works when different, so the following is used
    ACCOUNT_INTERVENTION_OWNER_CODE,
    DEPOSIT_HIRE_CONFIRMATION_PRODUCT_SUBTYPE_FOR_GET_HIRE_DATA,
    DEPOSIT_HIRE_CONFIRMATION_PRODUCT_SUBTYPE_FOR_GET_HIRE_DATA_CC,
    DEPOSIT_HIRE_CONFIRMATION_PRODUCT_TYPE,
    DEPOSIT_13_MONTHS_EXCEPCIONES_PRODUCT_TYPE,
    DEPOSIT_13_MONTHS_EXCEPCIONES_PRODUCT_SUBTYPE,
    DEPOSIT_13_MONTHS_EXCEPCIONES_PRODUCT_STANDARD,
    DEPOSIT_13_MONTHS_RENOVACION_EXCEPCION_PRODUCT_TYPE,
    DEPOSIT_13_MONTHS_RENOVACION_EXCEPCION_PRODUCT_SUBTYPE,
    DEPOSIT_13_MONTHS_RENOVACION_EXCEPCION_PRODUCT_STANDARD,
} = require('constants/index');

const {
    DEPOSIT_13_MONTHS_LEAK_RETENTION_PRODUCT_TYPE,
    DEPOSIT_13_MONTHS_LEAK_RETENTION_PRODUCT_SUBTYPE,
    DEPOSIT_13_MONTHS_LEAK_RETENTION_PRODUCT_STANDARD,
    DEPOSIT_13_MONTHS_DUE_DATES_PRODUCT_TYPE,
    DEPOSIT_13_MONTHS_DUE_DATES_PRODUCT_SUBTYPE,
    DEPOSIT_13_MONTHS_DUE_DATES_PRODUCT_STANDARD,
    DEPOSIT_13_MONTHS_LINKED_MATURITIES_PRODUCT_TYPE,
    DEPOSIT_13_MONTHS_LINKED_MATURITIES_PRODUCT_SUBTYPE,
    DEPOSIT_13_MONTHS_LINKED_MATURITIES_PRODUCT_STANDARD,
} = require('constants/contactCenter/hireDeposits');

const depositHireInformationIsFetching = isAccountChange => ({
    type: actionTypes.CONTRACT_METHOD_13_MONTHS_DEPOSIT_GET_DATA_IS_FETCHING,
    payload: {
        isAccountChange
    }
});

const depositHireInformationSuccess = response => ({
    type: actionTypes.CONTRACT_METHOD_13_MONTHS_DEPOSIT_GET_DATA_SUCCESS,
    payload: {
        response
    }
});

const depositHireInformationFailure = errorBody => ({
    type: actionTypes.CONTRACT_METHOD_13_MONTHS_DEPOSIT_GET_DATA_FAILURE,
    payload: {
        errorBody
    }
});

const isUserAbleToHireDepositThirteenMonths = () => ({
    type: actionTypes.CONTRACT_METHOD_13_MONTHS_DEPOSIT_IS_USER_ABLE_TO_HIRE
});

const requestDepositHireInformation = (immAccount, interveners, isAccountChange = false) => dispatch => {
    dispatch(depositHireInformationIsFetching(isAccountChange));

    const firstHolder = interveners.find( intervener => {
        return intervener.tipoIntervencion === ACCOUNT_INTERVENTION_OWNER_CODE &&
               intervener.ordenIntervencion === 1;
    });

    const currency = immAccount ? immAccount.getIn(['balance', 'currency']) : 'EUR';

    const requestData = {
        query: {
            moneda: currency,
            codigoDeEstandar: '0000001',
            rellamada: 'N',
            tipoac: 'B',
            producto: DEPOSIT_HIRE_CONFIRMATION_PRODUCT_TYPE,
            subProducto: __CONTACT_CENTER__ ?
                DEPOSIT_HIRE_CONFIRMATION_PRODUCT_SUBTYPE_FOR_GET_HIRE_DATA_CC :
                DEPOSIT_HIRE_CONFIRMATION_PRODUCT_SUBTYPE_FOR_GET_HIRE_DATA, // the value that works in PRE is 879
            titularTipoPersona: firstHolder.tipoPersona,
            titularCodigoPersona: firstHolder.numeroPersona
        }
    };
    return APIGet(dispatch, apiURLBuilder.getURL('hireDepositData'), requestData)
        .then(response => dispatch(depositHireInformationSuccess(response)))
        .catch(response => {
            if (response.body) {
                dispatch(depositHireInformationFailure(response.body));
            } else {
                throw response;
            }
        });
};

const refreshDepositHireInformation = (immAccount, interveners) => dispatch => {
    dispatch(requestDepositHireInformation(immAccount, interveners, true));
};

const requestDeposit13MonthsDueDatesHireInformation = (immAccount, interveners, isAccountChange = false) => dispatch => {
    dispatch(depositHireInformationIsFetching(isAccountChange));

    const firstHolder = interveners.find( intervener => {
        return intervener.tipoIntervencion === ACCOUNT_INTERVENTION_OWNER_CODE &&
               intervener.ordenIntervencion === 1;
    });

    const currency = immAccount ? immAccount.getIn(['balance', 'currency']) : 'EUR';

    const requestData = {
        query: {
            moneda: currency,
            codigoDeEstandar: DEPOSIT_13_MONTHS_DUE_DATES_PRODUCT_STANDARD,
            rellamada: 'N',
            tipoac: 'B',
            producto: DEPOSIT_13_MONTHS_DUE_DATES_PRODUCT_TYPE,
            subProducto: DEPOSIT_13_MONTHS_DUE_DATES_PRODUCT_SUBTYPE,
            titularTipoPersona: firstHolder.tipoPersona,
            titularCodigoPersona: firstHolder.numeroPersona
        }
    };
    return APIGet(dispatch, apiURLBuilder.getURL('hireDepositData'), requestData)
        .then(response => dispatch(depositHireInformationSuccess(response)))
        .catch(response => {
            if (response.body) {
                dispatch(depositHireInformationFailure(response.body));
            } else {
                throw response;
            }
        });
};



const requestDeposit13MonthsLinkedMaturitiesHireInformation = (immAccount, interveners, isAccountChange = false) => dispatch => {
    dispatch(depositHireInformationIsFetching(isAccountChange));

    const firstHolder = interveners.find( intervener => {
        return intervener.tipoIntervencion === ACCOUNT_INTERVENTION_OWNER_CODE &&
               intervener.ordenIntervencion === 1;
    });

    const currency = immAccount ? immAccount.getIn(['balance', 'currency']) : 'EUR';

    const requestData = {
        query: {
            moneda: currency,
            codigoDeEstandar: DEPOSIT_13_MONTHS_LINKED_MATURITIES_PRODUCT_STANDARD,
            rellamada: 'N',
            tipoac: 'B',
            producto: DEPOSIT_13_MONTHS_LINKED_MATURITIES_PRODUCT_TYPE,
            subProducto: DEPOSIT_13_MONTHS_LINKED_MATURITIES_PRODUCT_SUBTYPE,
            titularTipoPersona: firstHolder.tipoPersona,
            titularCodigoPersona: firstHolder.numeroPersona
        }
    };
    return APIGet(dispatch, apiURLBuilder.getURL('hireDepositData'), requestData)
        .then(response => dispatch(depositHireInformationSuccess(response)))
        .catch(response => {
            if (response.body) {
                dispatch(depositHireInformationFailure(response.body));
            } else {
                throw response;
            }
        });
};


const requestDeposit13MonthsLeakRetentionHireInformation = (immAccount, interveners, isAccountChange = false) => dispatch => {
    dispatch(depositHireInformationIsFetching(isAccountChange));

    const firstHolder = interveners.find( intervener => {
        return intervener.tipoIntervencion === ACCOUNT_INTERVENTION_OWNER_CODE &&
               intervener.ordenIntervencion === 1;
    });

    const currency = immAccount ? immAccount.getIn(['balance', 'currency']) : 'EUR';

    const requestData = {
        query: {
            moneda: currency,
            codigoDeEstandar: DEPOSIT_13_MONTHS_LEAK_RETENTION_PRODUCT_STANDARD,
            rellamada: 'N',
            tipoac: 'B',
            producto: DEPOSIT_13_MONTHS_LEAK_RETENTION_PRODUCT_TYPE,
            subProducto: DEPOSIT_13_MONTHS_LEAK_RETENTION_PRODUCT_SUBTYPE,
            titularTipoPersona: firstHolder.tipoPersona,
            titularCodigoPersona: firstHolder.numeroPersona
        }
    };
    return APIGet(dispatch, apiURLBuilder.getURL('hireDepositData'), requestData)
        .then(response => dispatch(depositHireInformationSuccess(response)))
        .catch(response => {
            if (response.body) {
                dispatch(depositHireInformationFailure(response.body));
            } else {
                throw response;
            }
        });
};

const requestDeposit13MonthsExcepcionesHireInformation = (immAccount, interveners, isAccountChange = false) => dispatch => {
    dispatch(depositHireInformationIsFetching(isAccountChange));

    const firstHolder = interveners.find( intervener => {
        return intervener.tipoIntervencion === ACCOUNT_INTERVENTION_OWNER_CODE &&
               intervener.ordenIntervencion === 1;
    });

    const currency = immAccount ? immAccount.getIn(['balance', 'currency']) : 'EUR';

    const requestData = {
        query: {
            moneda: currency,
            codigoDeEstandar: DEPOSIT_13_MONTHS_EXCEPCIONES_PRODUCT_STANDARD,
            rellamada: 'N',
            tipoac: 'B',
            producto: DEPOSIT_13_MONTHS_EXCEPCIONES_PRODUCT_TYPE,
            subProducto: DEPOSIT_13_MONTHS_EXCEPCIONES_PRODUCT_SUBTYPE,
            titularTipoPersona: firstHolder.tipoPersona,
            titularCodigoPersona: firstHolder.numeroPersona
        }
    };
    return APIGet({
        dispatch,
        endpoint: 'hireDepositData',
        params: requestData
    })
    .then(response => dispatch(depositHireInformationSuccess(response)))
    .catch(response => {
        if (response.body) {
            dispatch(depositHireInformationFailure(response.body));
        } else {
            throw response;
        }
    });
};

const requestDeposit13MonthsRenovacionExcepcionesHireInformation = (immAccount, interveners, isAccountChange = false) => dispatch => {
    dispatch(depositHireInformationIsFetching(isAccountChange));

    const firstHolder = interveners.find( intervener => {
        return intervener.tipoIntervencion === ACCOUNT_INTERVENTION_OWNER_CODE &&
               intervener.ordenIntervencion === 1;
    });

    const currency = immAccount ? immAccount.getIn(['balance', 'currency']) : 'EUR';

    const requestData = {
        query: {
            moneda: currency,
            codigoDeEstandar: DEPOSIT_13_MONTHS_RENOVACION_EXCEPCION_PRODUCT_STANDARD,
            rellamada: 'N',
            tipoac: 'B',
            producto: DEPOSIT_13_MONTHS_RENOVACION_EXCEPCION_PRODUCT_TYPE,
            subProducto: DEPOSIT_13_MONTHS_RENOVACION_EXCEPCION_PRODUCT_SUBTYPE,
            titularTipoPersona: firstHolder.tipoPersona,
            titularCodigoPersona: firstHolder.numeroPersona
        }
    };
    return APIGet({
        dispatch,
        endpoint: 'hireDepositData',
        params: requestData
    })
    .then(response => dispatch(depositHireInformationSuccess(response)))
    .catch(response => {
        if (response.body) {
            dispatch(depositHireInformationFailure(response.body));
        } else {
            throw response;
        }
    });
};

const refreshDeposit13MonthsDueDatesHireInformation = (immAccount, interveners) => dispatch => {
    dispatch(requestDeposit13MonthsDueDatesHireInformation(immAccount, interveners, true));
}

const refreshDeposit13MonthsLeakRetentionHireInformation = (immAccount, interveners) => dispatch => {
    dispatch(requestDeposit13MonthsLeakRetentionHireInformation(immAccount, interveners, true));
}

const refreshDeposit13MonthsExcepcionesHireInformation = (immAccount, interveners) => dispatch => {
    dispatch(requestDeposit13MonthsExcepcionesHireInformation(immAccount, interveners, true));
}

const refreshDeposit13MonthsLinkedMaturitiesHireInformation = (immAccount, interveners) => dispatch => {
    dispatch(requestDeposit13MonthsLinkedMaturitiesHireInformation(immAccount, interveners, true));
};

const refreshDeposit13MonthsRenovacionExcepcionesHireInformation = (immAccount, interveners) => dispatch => {
    dispatch(requestDeposit13MonthsRenovacionExcepcionesHireInformation(immAccount, interveners, true));
}

const setDepositThirteenMonths = (dispatch, data, getState) => {
    const requestData = {
        query: data
    };
    const immContracts = getState().contracts;
    const contractType = immContracts.get('contract_type');
    const termsAndCondHiringData = [immContracts.get('hiring_data_contract').toJS()];

    return APIPost(dispatch, apiURLBuilder.getURL('hireDepositConfirmation'), requestData)
        .then(response => {
            dispatch(hireContractSuccess(response));
            dispatch(setTermsAndCondsInfo(contractType, termsAndCondHiringData));
        })
        .catch(response => {
            if (response.error) {
                dispatch(hireContractFailure(response.error));
            } else {
                throw response;
            }
        });
};

const hireDepositThirteenMonths = params => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const data = Object.assign(params, { dataToken });
        dispatch(gdprConsentsActions.updateConsents(dataToken))
            .then(() => setDepositThirteenMonths(dispatch, data, getState))
            .catch(response => {
                if(!!response.error) {
                    setDepositThirteenMonths(dispatch, data, getState);
                } else {
                    throw response;
                }
            });
    };

    new Promise(function() {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });
};

module.exports = {
    hireDepositThirteenMonths,
    isUserAbleToHireDepositThirteenMonths,
    refreshDepositHireInformation,
    requestDepositHireInformation,
    refreshDeposit13MonthsDueDatesHireInformation,
    refreshDeposit13MonthsExcepcionesHireInformation,
    refreshDeposit13MonthsLeakRetentionHireInformation,
    refreshDeposit13MonthsLinkedMaturitiesHireInformation,
    refreshDeposit13MonthsRenovacionExcepcionesHireInformation
};
